import React from "react";
import ReactDOM from "react-dom";
import GateKeeper from "GateKeeper";
import "index.css";

ReactDOM.render(
  <React.StrictMode>
    <GateKeeper />
  </React.StrictMode>,
  document.getElementById("root")
);
